import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiSensorLogsService extends ApiBaseService {

  protected headers: Headers;
  isLoading: boolean = false;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  getLogs(params = {}): Promise<any> {
    let queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
    let url = `${this.apiAuthStore.url}/api/v1/sensor/logs?${queryString}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  getSyncLogs(params = {}): Promise<any> {
    let queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
    let url = `${this.apiAuthStore.url}/api/v1/sensor/syncLogs?${queryString}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }


}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-sensor-logs.service.ts